var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyDrawer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 23V22.25V22.25V23ZM29.5 25H30.25V25H29.5ZM27.5 29V29.75V29ZM4.5 29L4.5 29.75H4.5V29ZM2.5 27H1.75V27H2.5ZM4.5 23V22.25V23ZM13.6422 24.8551L13.0531 25.3193L13.6422 24.8551ZM27.5 23V23.75C28.1904 23.75 28.75 24.3096 28.75 25H29.5H30.25C30.25 23.4812 29.0188 22.25 27.5 22.25V23ZM29.5 25H28.75V27H29.5H30.25V25H29.5ZM29.5 27H28.75C28.75 27.6904 28.1904 28.25 27.5 28.25V29V29.75C29.0188 29.75 30.25 28.5188 30.25 27H29.5ZM27.5 29V28.25H4.5V29V29.75H27.5V29ZM4.5 29L4.5 28.25C3.80964 28.25 3.25 27.6904 3.25 27H2.5H1.75C1.75 28.5188 2.98122 29.75 4.5 29.75L4.5 29ZM2.5 27H3.25V25H2.5H1.75V27H2.5ZM2.5 25H3.25C3.25 24.3096 3.80964 23.75 4.5 23.75V23V22.25C2.98122 22.25 1.75 23.4812 1.75 25H2.5ZM4.5 23V23.75H11V23V22.25H4.5V23ZM13.6422 24.8551L13.0531 25.3193C13.7385 26.1892 14.804 26.75 16 26.75V26V25.25C15.283 25.25 14.6445 24.9155 14.2313 24.391L13.6422 24.8551ZM16 26V26.75C17.196 26.75 18.2615 26.1892 18.9469 25.3193L18.3578 24.8551L17.7687 24.391C17.3555 24.9155 16.717 25.25 16 25.25V26ZM21 23V23.75H27.5V23V22.25H21V23ZM18.3578 24.8551L18.9469 25.3193C19.2874 24.8871 19.6276 24.4822 19.9942 24.1841C20.3567 23.8894 20.6834 23.75 21 23.75V23V22.25C20.212 22.25 19.5594 22.6044 19.0479 23.0203C18.5404 23.4329 18.1118 23.9555 17.7687 24.391L18.3578 24.8551ZM11 23V23.75C11.3166 23.75 11.6433 23.8894 12.0058 24.1841C12.3724 24.4822 12.7126 24.8871 13.0531 25.3193L13.6422 24.8551L14.2313 24.391C13.8882 23.9555 13.4596 23.4329 12.9521 23.0203C12.4406 22.6044 11.788 22.25 11 22.25V23Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 25L6.04415 14.3675C6.31638 13.5509 7.08066 13 7.94152 13H24.0585C24.9193 13 25.6836 13.5509 25.9558 14.3675L29.5 25",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 2L16 8",
    stroke: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2493 4.60538L21.2493 9.80153",
    stroke: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.74927 4.60037L10.7493 9.79653",
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyDrawer);
export default __webpack_public_path__ + "static/media/empty-drawer.adbd5b0924f2c4964f037381df9d6335.svg";
export { ForwardRef as ReactComponent };